import { render, staticRenderFns } from "./materialDialog.vue?vue&type=template&id=db0918aa&scoped=true"
import script from "./materialDialog.vue?vue&type=script&lang=js"
export * from "./materialDialog.vue?vue&type=script&lang=js"
import style0 from "./materialDialog.vue?vue&type=style&index=0&id=db0918aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0918aa",
  null
  
)

export default component.exports